exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".horizontal-app-menu .menu-bar > ul {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: row;\n          flex-flow: row; }\n\n.horizontal-app-menu .ghost-nav-dropdown {\n  height: 0; }\n\n.horizontal-app-menu .ghost-ul {\n  visibility: hidden;\n  position: absolute;\n  pointer-events: none; }\n\n.horizontal-app-menu .horizontal-menu-backdrop-dekstop {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 1; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/@hornbillfx/components/horizontal-menu/horizontal-menu.component.scss
// module id = ../../../../../src/app/@hornbillfx/components/horizontal-menu/horizontal-menu.component.scss
// module chunks = main